import { __assign, __extends } from "tslib";
import { each, isNil, isFunction, isObject } from '@antv/util';
import { vec2 } from '@antv/matrix-util';
import AxisBase from './base';
import * as OverlapUtil from './overlap';
var Circle = /** @class */ (function (_super) {
    __extends(Circle, _super);
    function Circle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Circle.prototype.getDefaultCfg = function () {
        var cfg = _super.prototype.getDefaultCfg.call(this);
        return __assign(__assign({}, cfg), { type: 'circle', locationType: 'circle', center: null, radius: null, startAngle: -Math.PI / 2, endAngle: (Math.PI * 3) / 2 });
    };
    Circle.prototype.getLinePath = function () {
        var center = this.get('center');
        var x = center.x;
        var y = center.y;
        var rx = this.get('radius');
        var ry = rx;
        var startAngle = this.get('startAngle');
        var endAngle = this.get('endAngle');
        var path = [];
        if (Math.abs(endAngle - startAngle) === Math.PI * 2) {
            path = [['M', x, y - ry], ['A', rx, ry, 0, 1, 1, x, y + ry], ['A', rx, ry, 0, 1, 1, x, y - ry], ['Z']];
        }
        else {
            var startPoint = this.getCirclePoint(startAngle);
            var endPoint = this.getCirclePoint(endAngle);
            var large = Math.abs(endAngle - startAngle) > Math.PI ? 1 : 0;
            var sweep = startAngle > endAngle ? 0 : 1;
            path = [
                ['M', x, y],
                ['L', startPoint.x, startPoint.y],
                ['A', rx, ry, 0, large, sweep, endPoint.x, endPoint.y],
                ['L', x, y],
            ];
        }
        return path;
    };
    Circle.prototype.getTickPoint = function (tickValue) {
        var startAngle = this.get('startAngle');
        var endAngle = this.get('endAngle');
        var angle = startAngle + (endAngle - startAngle) * tickValue;
        return this.getCirclePoint(angle);
    };
    // è·ååç´äºåæ è½´çåé
    Circle.prototype.getSideVector = function (offset, point) {
        var center = this.get('center');
        var vector = [point.x - center.x, point.y - center.y];
        var factor = this.get('verticalFactor');
        var vecLen = vec2.length(vector);
        vec2.scale(vector, vector, (factor * offset) / vecLen);
        return vector;
    };
    // è·åæ²¿åæ è½´æ¹åçåé
    Circle.prototype.getAxisVector = function (point) {
        var center = this.get('center');
        var vector = [point.x - center.x, point.y - center.y];
        return [vector[1], -1 * vector[0]]; // è·åé¡ºæ¶éæ¹åçåé
    };
    // æ ¹æ®åå¿ååå¾è·åç¹
    Circle.prototype.getCirclePoint = function (angle, radius) {
        var center = this.get('center');
        radius = radius || this.get('radius');
        return {
            x: center.x + Math.cos(angle) * radius,
            y: center.y + Math.sin(angle) * radius,
        };
    };
    /**
     * æ¯å¦å¯ä»¥æ§è¡æä¸ overlap
     * @param name
     */
    Circle.prototype.canProcessOverlap = function (name) {
        var labelCfg = this.get('label');
        // å¯¹ autoRotateï¼å¦æéç½®äºæè½¬è§åº¦ï¼ç´æ¥è¿è¡åºå®è§åº¦æè½¬
        if (name === 'autoRotate') {
            return isNil(labelCfg.rotate);
        }
        // é»è®¤ææ overlap é½å¯æ§è¡
        return true;
    };
    Circle.prototype.processOverlap = function (labelGroup) {
        var _this = this;
        var labelCfg = this.get('label');
        var titleCfg = this.get('title');
        var verticalLimitLength = this.get('verticalLimitLength');
        var labelOffset = labelCfg.offset;
        var limitLength = verticalLimitLength;
        var titleHeight = 0;
        var titleSpacing = 0;
        if (titleCfg) {
            titleHeight = titleCfg.style.fontSize;
            titleSpacing = titleCfg.spacing;
        }
        if (limitLength) {
            limitLength = limitLength - labelOffset - titleSpacing - titleHeight;
        }
        var overlapOrder = this.get('overlapOrder');
        each(overlapOrder, function (name) {
            if (labelCfg[name] && _this.canProcessOverlap(name)) {
                _this.autoProcessOverlap(name, labelCfg[name], labelGroup, limitLength);
            }
        });
        if (titleCfg) {
            if (isNil(titleCfg.offset)) {
                // è°æ´ title ç offset
                var length_1 = labelGroup.getCanvasBBox().height;
                // å¦æç¨æ·æ²¡æè®¾ç½® offsetï¼åèªå¨è®¡ç®
                titleCfg.offset = labelOffset + length_1 + titleSpacing + titleHeight / 2;
            }
        }
    };
    Circle.prototype.autoProcessOverlap = function (name, value, labelGroup, limitLength) {
        var _this = this;
        var hasAdjusted = false;
        var util = OverlapUtil[name];
        if (limitLength > 0) {
            if (value === true) {
                // true å½¢å¼çéç½®ï¼ä½¿ç¨ overlap é»è®¤ççå¤çæ¹æ³è¿è¡å¤ç
                hasAdjusted = util.getDefault()(false, labelGroup, limitLength);
            }
            else if (isFunction(value)) {
                // åè°å½æ°å½¢å¼çéç½®ï¼ ç¨æ·å¯ä»¥ä¼ å¥åè°å½æ°
                hasAdjusted = value(false, labelGroup, limitLength);
            }
            else if (isObject(value)) {
                // object å½¢å¼çéç½®æ¹å¼ï¼åæ¬ å¤çæ¹æ³ typeï¼ åå¯éåæ°éç½® cfg
                var overlapCfg = value;
                if (util[overlapCfg.type]) {
                    hasAdjusted = util[overlapCfg.type](false, labelGroup, limitLength, overlapCfg.cfg);
                }
            }
            else if (util[value]) {
                // å­ç¬¦ä¸²ç±»åçéç½®ï¼æç§åç§°æ§è¡ overlap å¤çæ¹æ³
                hasAdjusted = util[value](false, labelGroup, limitLength);
            }
        }
        if (name === 'autoRotate') {
            // ææ¬æè½¬åï¼ææ¬çå¯¹é½æ¹å¼å¯è½å°±ä¸åéäº
            if (hasAdjusted) {
                var labels = labelGroup.getChildren();
                var verticalFactor_1 = this.get('verticalFactor');
                each(labels, function (label) {
                    var textAlign = label.attr('textAlign');
                    if (textAlign === 'center') {
                        // å±ä¸­çææ¬éè¦è°æ´æè½¬åº¦
                        var newAlign = verticalFactor_1 > 0 ? 'end' : 'start';
                        label.attr('textAlign', newAlign);
                    }
                });
            }
        }
        else if (name === 'autoHide') {
            var children = labelGroup.getChildren().slice(0); // å¤å¶æ°ç»ï¼å é¤æ¶ä¸ä¼åºé
            each(children, function (label) {
                if (!label.get('visible')) {
                    if (_this.get('isRegister')) {
                        // å·²ç»æ³¨åè¿äºï¼åå é¤
                        _this.unregisterElement(label);
                    }
                    label.remove(); // é²æ­¢ label æ°éå¤ªå¤ï¼æä»¥ç»ä¸å é¤
                }
            });
        }
    };
    return Circle;
}(AxisBase));
export default Circle;
//# sourceMappingURL=circle.js.map